import { BuiltFieldAttributes, FieldBuilderParams } from './baseFieldBuilder'

export default function widgetMapBuilder({ rawField }: FieldBuilderParams): Partial<BuiltFieldAttributes> {
  return {
    latitude: rawField.latitude,
    longitude: rawField.longitude,
    navAddress: rawField.navAddress,
  }
}
